import { Tab, Tabs, Grid, Paper } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { TabPanel } from '../../../components/tab-panel';
import { ProjectsTab } from './project-tab/projects-tab';
import { LotsTab } from './lots-tab/lots-tab';
import { ServicesBundleTab } from './services-bundle-tab/services-tab';
import { CustomerDetailsTab } from './office-contacts-tab/customer-contacts-tab';
import { PlanTab } from './plan-tab/plan-tabs';
import { FilesTab } from './file-tab/files.tab';
import { UserPermissionName } from '../../../models/user-permission-name';
import { useAuthorize } from '../../../hooks/use-authorize';
import { ServicesTab } from './services-tab/services-tab';
import { ContractsTab } from './contract-tab/contracts.tab';

interface DetailsTabs {
  customerID: number;
  officeID: number;
  contracts: any;
  permissionForTab: any;
}
export const DetailsTabs = ({ customerID, officeID, contracts, permissionForTab }: DetailsTabs) => {
  const { id } = useParams();
  const [value, setValue] = useState('projects');

  const handleTabsChange = (event: any, value: any) => {
    setValue(value);
  };

  const availableTabs = useMemo(
    () =>
      [
        permissionForTab?.projectTab && 'projects',
        permissionForTab?.unitTab && 'lots',
        permissionForTab?.contactTab && 'customer-contacts',
        permissionForTab?.serviceTab && 'services',
        permissionForTab?.fileTab && 'files',
        permissionForTab?.contractTab && 'contracts',
        permissionForTab?.serviceBundleTab && 'services-bundle',
        permissionForTab?.planTab && 'plans',
      ].filter(Boolean),
    [permissionForTab]
  );

  useEffect(() => {
    if (!availableTabs.includes(value)) {
      setValue(availableTabs[0] as string);
    }
  }, [availableTabs]);

  if (!id) {
    return <div>Invalid Office</div>;
  }

  const isPlanEnabled = process.env.REACT_APP_PLAN_FLAG === 'true';
  const isBundlePermission = useAuthorize([UserPermissionName?.VIEW_SERVICE_BUNDLE]);
  const isViewContractPermission = useAuthorize([UserPermissionName?.VIEW_CONTRACT_OFFICE]);

  return (
    <Paper elevation={0} sx={{ mt: 2 }}>
      <Grid item>
        <Tabs value={value} onChange={handleTabsChange}>
          <Tab value="projects" label="Projects" hidden={!permissionForTab?.projectTab} />
          <Tab value="lots" label="Lots/Units" hidden={!permissionForTab?.unitTab} />
          <Tab value="customer-contacts" label="Office Contacts" hidden={!permissionForTab?.contactTab} />
          <Tab value="services" label="Services" hidden={!permissionForTab?.serviceTab} />
          <Tab value="services-bundle" label="Service Bundles" hidden={!permissionForTab?.serviceBundleTab} />
          <Tab value="plans" label="Plans" hidden={!isPlanEnabled || !permissionForTab?.planTab} />
          <Tab value="files" label="Files" hidden={!permissionForTab?.fileTab} />
          <Tab value="contracts" label="Contracts" hidden={!permissionForTab?.contractTab} />
        </Tabs>

        {value === 'projects' && permissionForTab?.projectTab && (
          <TabPanel selectedValue={value} value="projects">
            <ProjectsTab customerID={customerID} officeID={officeID} />
          </TabPanel>
        )}
        {value === 'lots' && permissionForTab?.unitTab && (
          <TabPanel selectedValue={value} value="lots">
            <LotsTab officeID={Number(id)} />
          </TabPanel>
        )}
        {value === 'services-bundle' && permissionForTab?.serviceBundleTab && (
          <TabPanel selectedValue={value} value="services-bundle">
            <ServicesBundleTab officeID={Number(id)} />
          </TabPanel>
        )}
        {value === 'services' && permissionForTab?.serviceTab && (
          <TabPanel selectedValue={value} value="services">
            <ServicesTab officeID={Number(id)} />
          </TabPanel>
        )}

        {value === 'customer-contacts' && permissionForTab?.contactTab && (
          <TabPanel selectedValue={value} value="customer-contacts">
            <CustomerDetailsTab officeID={Number(id)} />
          </TabPanel>
        )}
        {value === 'plans' && permissionForTab?.planTab && (
          <TabPanel selectedValue={value} value="plans">
            <PlanTab customerID={Number(customerID)} officeID={Number(id)} />;
          </TabPanel>
        )}
        {value === 'files' && permissionForTab?.fileTab && (
          <TabPanel selectedValue={value} value="files">
            <FilesTab officeID={Number(id)} />
          </TabPanel>
        )}
        {value === 'contracts' && permissionForTab?.contractTab && (
          <TabPanel selectedValue={value} value="contracts">
            <ContractsTab contracts={contracts} />
          </TabPanel>
        )}
      </Grid>
    </Paper>
  );
};
